module.exports = __webpack_public_path__ + "img/thinkingComputer.8b84b0e8.jpg";